// extracted by mini-css-extract-plugin
export default {"user_menu_container":"index_user_menu_container__+pkMx","user_menu_avatar":"index_user_menu_avatar__otfV1"};